import { render, staticRenderFns } from "./BannerDefinitions.vue?vue&type=template&id=1fcf1460"
import script from "./BannerDefinitions.vue?vue&type=script&lang=js"
export * from "./BannerDefinitions.vue?vue&type=script&lang=js"
import style0 from "./BannerDefinitions.vue?vue&type=style&index=0&id=1fcf1460&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCombobox,VDataTable,VIcon,VImg,VSpacer})
